import classNames from 'classnames'
import * as React from 'react'
import './DataList.scss'

export interface IDataListItemProps {
  className?: string
  label: React.ReactNode
  labelClassName?: string
  labelStyle?: React.CSSProperties
  style?: React.CSSProperties
  value: React.ReactNode
  valueClassName?: string
  valueStyle?: React.CSSProperties
  visible?: boolean
}

export class DataListItem extends React.PureComponent<IDataListItemProps> {
  public render() {
    if (this.props.visible === false) {
      return null
    }

    return (
      <div
        className={classNames('data-list-item', this.props.className)}
        style={this.props.style}
      >
        <div
          className={classNames(
            'data-list-item-label',
            this.props.labelClassName,
          )}
          style={this.props.labelStyle}
        >
          {this.props.label}
        </div>
        <div
          className={classNames(
            'data-list-item-value',
            this.props.valueClassName,
          )}
          style={this.props.valueStyle}
        >
          {this.props.value}
        </div>
      </div>
    )
  }
}
